export default "__VITE_ASSET__8zIr2UNY__"